import { render } from "./CreateInviteForm.vue?vue&type=template&id=5c10d4e1"
import script from "./CreateInviteForm.vue?vue&type=script&lang=js"
export * from "./CreateInviteForm.vue?vue&type=script&lang=js"

import "./CreateInviteForm.vue?vue&type=style&index=0&id=5c10d4e1&lang=css"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__